import axios from '@/core/plugins/axios';
import store from "@/core/store"
import {DISABLE_WAITING, ENABLE_WAITING} from "@/core/store/modules/generic/constants";

require('@/core/services/api/onRequest')
require('@/core/services/api/onResponse')


const api = {

    setAuthorizationHeader(value) {
        axios.defaults.headers.Authorization = 'Bearer ' + value
    },

    setCustomHeader(header, value) {
        axios.defaults.headers.common[header] = value
    },

    removeCustomHeader(header) {
        axios.defaults.headers.common[header] = {}
    },

    removeAuthorizationHeader() {
        axios.defaults.headers.Authorization = {}
    },

    waiting(action = 'fetch') {
        this.action = action
        return this
    },

    get(...params) {
        let action = this.action
        this.action = null
        return this.execute('get', action, ...params)
    },

    post(...params) {
        let action = this.action
        this.action = null
        return this.execute('post', action, ...params)
    },

    put(...params) {
        let action = this.action
        this.action = null
        return this.execute('put', action, ...params)
    },

    delete(...params) {
        let action = this.action
        this.action = null
        return this.execute('delete', action, ...params)
    },

    execute(requestType, action = null, ...params) {
        if (action) {
            this.actions
            store.commit(ENABLE_WAITING, action)
        }
        return new Promise((resolve, reject) => {
            axios[requestType](...params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                }).finally(() => {
                if (action) {
                    store.commit(DISABLE_WAITING, action)
                }
            })
        })
    },

};

export default api

